import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Banner extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      aspectRatio,
      isDownloadApp,
      dataLocale: { VW, AUTO },
    } = this.props;
    const bannerStyle = {
      width: `100${VW}`,
      height: aspectRatio ? `${100 / aspectRatio}${VW}` : AUTO,
    };

    return (
      <section
        className={`banner pos-rel${isDownloadApp ? ' download-app' : ''}`}
        style={bannerStyle}
      >
        {this.props.children}
      </section>
    );
  }
}

Banner.propTypes = {
  children: PropTypes.element.isRequired,
  aspectRatio: PropTypes.number,
};

Banner.defaultProps = {
  aspectRatio: 1,
};

export default Banner;
